class CaseStudiesGrid extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-filter-select]');
    this.grid = this.querySelector('[data-case-studies-grid]');
    if (!this.select || !this.grid) return;

    this.units = Array.from(this.grid.children);
    this.emptyMessage = this.querySelector('[data-empty-message]');
    this.handlesByUnit = new Map();

    this.units.forEach((unit) => {
      const item = unit.matches('[data-case-study]') ? unit : unit.querySelector('[data-case-study]');
      const handles = item ? (item.dataset.productHandles || '').split(',').filter(Boolean) : [];
      this.handlesByUnit.set(unit, new Set(handles));
    });

    this.select.addEventListener('change', () => this.filter());
  }

  filter() {
    const handle = this.select.value;
    this.select.classList.toggle('has-value', handle !== '');

    const visible =
      handle === '' ? this.units : this.units.filter((unit) => this.handlesByUnit.get(unit).has(handle));

    // Re-parenting instead of [hidden] so :nth-child recomputes the layout
    // pattern over the visible cards only.
    this.grid.replaceChildren(...visible);

    if (this.emptyMessage) {
      const isEmpty = visible.length === 0;
      this.emptyMessage.textContent = isEmpty ? this.emptyMessage.dataset.text : '';
      this.emptyMessage.hidden = !isEmpty;
    }
  }
}

customElements.define('case-studies-grid', CaseStudiesGrid);
